export const SET_ALL_ACTIVIRY = 'SET_ALL_ACTIVIRY' // 设置特价活动数据信息
export const RESET_ALL_ACTIVIRY = 'RESET_ALL_ACTIVIRY' // 重新设置特价活动数据信息
export const EMPTY_ALL_ACTIVIRY = 'EMPTY_ALL_ACTIVIRY' // 设置特价活动数据为空
export const SPECIAL_OFFERS = 'SPECIAL_OFFERS' // 添加特价商品
export const MODIFY_GOODS_PICTURE = 'MODIFY_GOODS_PICTURE' // 设置商品的图片
export const MODIFY_GOODS_STORES = 'MODIFY_GOODS_STORES' // 设置商品所属的门店列表
export const MODIFY_GOODS_START_END_TIME = 'MODIFY_GOODS_START_END_TIME' // 设置商品的起止时间
export const SET_INPUT_TIMER_SCROLL = 'SET_INPUT_TIMER_SCROLL' // 设置input元素的定时器
export const CLEAR_INPUT_TIMER_SCROLL = 'CLEAR_INPUT_TIMER_SCROLL' // 清除input元素的定时器
export const SET_ACTIVITY_FROM_STORE = 'SET_ACTIVITY_FROM_STORE' // 设置活动数据从商品库中选择
export const SET_STORE_LIST = 'SET_STORE_LIST' // 设置活动数据从商品库中选择
export const SET_CLIENT_HEIGHT = 'SET_CLIENT_HEIGHT' // 设置当前窗口的高度
export const SET_GOODS_DESC_STATUS = 'SET_GOODS_DESC_STATUS' // 设置是否已经获取商品描述
export const CLEAR_STORE_LIST = 'CLEAR_STORE_LIST' // 清空地址选择
export const CLEAR_DELIVERY_INFO = 'CLEAR_DELIVERY_INFO' // 清空配送方式
export const SET_DELIVERY_INFO = 'SET_DELIVERY_INFO' // 设置配送方式
export const GET_DELIVERY_INFO = 'GET_DELIVERY_INFO' // 获取配送方式
export const SET_EDITOR_CONTENT = 'SET_EDITOR_CONTENT' // 设置富文本内容
